import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import { meQuery } from "@/features/auth/session";
import { ConsentPage } from "@/features/oauth/ConsentPage";

/**
 * Where an app connecting over MCP sends the person: the board's authorize
 * endpoint redirects here with ?request=<id>, or with ?error=<code> when the
 * request couldn't be accepted. Signing in first, if needed, comes back here.
 */
export const Route = createFileRoute("/oauth/consent")({
  validateSearch: z.object({
    request: z.string().max(100).optional().catch(undefined),
    error: z.string().max(50).optional().catch(undefined),
  }),
  beforeLoad: async ({ context, search, location }) => {
    if (search.error !== undefined) return;
    const me = await context.queryClient
      .query({ ...meQuery, staleTime: "static" })
      .catch(() => null);
    if (!me) {
      throw redirect({ to: "/login", search: { returnTo: location.href } });
    }
  },
  component: ConsentPage,
});
